module.exports = __webpack_public_path__ + "static/media/gif-black.11021297.svg";